export const money = (v, cur) =>
  v == null || isNaN(v) ? "—" : `${Number(v).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}${cur ? " " + cur : ""}`;
export const pct = (v) => (v == null || isNaN(v) ? "—" : `${Number(v).toFixed(1)}%`);
export const fdate = (s) => {
  if (!s) return "—";
  const d = s.slice(0, 10).split("-");
  return d.length === 3 ? `${d[2]}/${d[1]}/${d[0]}` : s;
};
export const fdt = (s) => (s ? new Date(s).toLocaleString((localStorage.getItem("lang") || "es") === "en" ? "en-GB" : "es-MX", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
export const marginTone = (m) =>
  m >= 35 ? "bg-emerald-50 text-emerald-700 border-emerald-200" : m >= 25 ? "bg-amber-50 text-amber-700 border-amber-200" : "bg-red-50 text-red-700 border-red-200";
